import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class WitchLake1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WITCH_LAKE1;
}

export default WitchLake1PoiTileEntity;
